import React from "react";
import ControlPanel from "./ControlPanel";

const ControlUnknown = () => {
  return <ControlPanel id={-1} mode={"disabled"} title={"UNKNOWN"} />;
};

export default ControlUnknown;
